import conference from "./conference"

export default {
  phoneNumber: "5511952781145",
  whatsAppMessage: `Olá, gostaria de falar sobre a React Conf Brasil ${conference.year}`,
  email: "reactconfbr@gmail.com",
}
